module.exports = __webpack_public_path__ + "static/media/DSCBracketsSquare.e52543dd.png";